module.exports = {"_id":"","date":"","fn":false,"message":"There is an app update available! See what's new - https://wiki.drzzle.com/changelog.","status":"unread","version":false,"type":"upgrade"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/alert.json
// module id = 3lxe
// module chunks = 0